import SEOHead from '@/components/base/SEOHead';
import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import FeatureGrid from './components/FeatureGrid';
import HowToUse from './components/HowToUse';
import DailyReportDemo from './components/DailyReportDemo';
import ExcelComparison from './components/ExcelComparison';
import MultilingualSection from './components/MultilingualSection';
import PricingSection from './components/PricingSection';
import SecuritySection from './components/SecuritySection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

const HOME_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': '”おもいむすび”',
  'description': 'AIプロジェクト管理ツール ”おもいむすび”。企画書やPDFをアップロードするだけでAIがタスクを分解し、WBSとガントチャートを自動生成。日英タイ3言語対応。無料で試せます（期限なし）。',
  'url': 'https://omoimusubi.asia',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': 'https://omoimusubi.asia/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const ORG_DATA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': '株式会社cafoot',
  'url': 'https://omoimusubi.asia',
  'description': 'AIを活用したプロジェクト管理SaaS「”おもいむすび”」を提供する日本企業。',
  'foundingDate': '2024',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'JP',
    'addressRegion': '東京都',
    'addressLocality': '千代田区',
  },
};

export default function Home() {
  return (
    <Layout showBreadcrumb={false}>
      <SEOHead
        title="AIプロジェクト管理ツール ”おもいむすび”｜WBS・ガントチャートを自動生成"
        description="”おもいむすび”は、企画書やPDFをアップロードするだけでAIがタスクを分解し、WBSとガントチャートを自動生成するプロジェクト管理ツールです。日報から進捗を更新し、ファイル・チャット・タスクを一元管理。日英タイ3言語対応。無料で試せます（期限なし）。"
        keywords="AI プロジェクト管理ツール,プロジェクト管理 AIツール,AI タスク管理ツール,プロジェクト管理 自動化,プロジェクト管理 SaaS"
        canonical="https://omoimusubi.asia/"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(HOME_STRUCTURED_DATA) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ORG_DATA) }} />

      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <FeatureGrid />
      <HowToUse />
      <DailyReportDemo />
      <ExcelComparison />
      <MultilingualSection />
      <PricingSection />
      <SecuritySection />
      <FAQSection />
      <FinalCTA />
    </Layout>
  );
}